import React from 'react';
import Localize from 'react-intl-universal';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { concatAddress } from '@common/Util';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.booking.backgroundField,
  height: '100%',
  padding: '1rem',
  overflow: 'auto',
  textAlign: 'left'
}));

const paddingBasedOnScreenSize = {
  paddingLeft: { xs: '0 !important', sm: '16px' },
  paddingRight: { xs: '5px', sm: '16px' }
};

const StyledHeader = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  paddingTop: 0,
  paddingBottom: '0.1rem',
  marginBottom: '0.6rem !important',
  fontSize: '1rem',
  color: theme.palette.booking.header
}));

const SingleLineInfo = ({ label, text }) => (
  <Grid item xs={12} sm={12} sx={{ display: 'flex', gap: 1, lineHeight: '1.5rem' }}>
    <Typography variant='span' fontWeight={'bold'}>
      {`${label}:`}
    </Typography>
    <Typography variant='span'>{text}</Typography>
  </Grid>
);

const BillingInformation = ({ billingData }) => {
  return (
    <>
      <StyledBox>
        <Grid
          item
          xs={12}
          sm={12}
          sx={{
            ...paddingBasedOnScreenSize,
            mb: '0px !important',
            pt: '0px !important',
            textAlign: 'left'
          }}
        >
          <StyledHeader>{Localize.get('Booking.billingAddressRecipient')}</StyledHeader>
        </Grid>
        <SingleLineInfo
          label={Localize.get('Booking.recipient')}
          text={`${billingData?.firstName} ${billingData?.lastName}`}
        />
        <SingleLineInfo label={Localize.get('Booking.company')} text={billingData?.companyName} />
        <SingleLineInfo
          label={Localize.get('EventDetails.address')}
          text={concatAddress(billingData?.addressDto)}
        />
        <SingleLineInfo label={Localize.get('Booking.email')} text={billingData?.emailDto?.email} />
        <SingleLineInfo label={Localize.get('Booking.phone')} text={billingData?.phoneDto?.phone} />

        <StyledHeader sx={{ pt: 3, display: 'none' }}>
          {Localize.get('Booking.paymentMethod')}
        </StyledHeader>
        <Typography sx={{ textAlign: 'left', fontWeight: 'bold', display: 'none' }}>
          {Localize.get('Booking.byInvoice')}
        </Typography>
      </StyledBox>
    </>
  );
};
export default BillingInformation;
